import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-header',
  imports: [RouterModule],
  templateUrl: './header.html',
  standalone: true,
  styleUrl: './header.scss'
})
export class Header {
  private authService = inject(AuthenticationService);
  showLogoutModal = false;

  veriflogout(): void {
    this.showLogoutModal = true;
  }

  cancelLogout(): void {
    this.showLogoutModal = false;
  }

  logout(): void {
    this.showLogoutModal = false;
    this.authService.logout();
  }

  get isLoggedIn(): boolean {
    return !!sessionStorage.getItem('auth_token');
  }
}
